import "./utils/main.css";
import { BrowserRouter } from "react-router-dom";
import AppHome from "./screens/home/app";
import LandscapeGuard from "./components/ui/landscape-guard/LandscapeGuard";
import { PrimeReactProvider, addLocale } from "primereact/api";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d71787faf540bd7144d5c6acf1bdc891@o4511434441293824.ingest.us.sentry.io/4511434449485824",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

function App() {
  addLocale("es", {
    startsWith: "Comienza con",
    notContains: "No contiene",
    endsWith: "Termina con",
    equals: "Es igual a",
    notEquals: "No es igual a",
    noFilter: "Sin filtro",
    filter: "Filtrar",
    contains: "Contiene",
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
  });

  const value = {
    locale: "es",
  };

  return (
    <Sentry.ErrorBoundary
      fallback={<p>Lo sentimos, ha ocurrido un error inesperado.</p>}
    >
      <BrowserRouter basename="/">
        <PrimeReactProvider value={value}>
          <AppHome />
          <LandscapeGuard />
        </PrimeReactProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
